var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 329.27,
    height: 329.263,
    viewBox: "0 0 329.27 329.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.8,164.77,323.012,36.555A21.329,21.329,0,0,0,292.848,6.391L164.633,134.606,36.422,6.391A21.329,21.329,0,0,0,6.258,36.555L134.469,164.77,6.258,292.985a21.329,21.329,0,1,0,30.164,30.164L164.633,194.934,292.848,323.149a21.329,21.329,0,0,0,30.164-30.164Zm0,0",
    transform: "translate(0 -0.136)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClose);
export default __webpack_public_path__ + "static/media/white-close.5f9972d2962ddb3c152d74794047de30.svg";
export { ForwardRef as ReactComponent };